import { defineComponent as _defineComponent } from 'vue'
import { TextDisplay } from '../TextDisplay';

import { CustomOperation } from '@/modules/trade/services/custom-operations';
import { TooltipTypes } from '../../types';

interface Props {
  customOperationData: CustomOperation;
}
interface Emits {
  (e: 'tooltip-click', type: TooltipTypes): void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'OperationResult',
  props: {
    customOperationData: null
  },
  emits: ["tooltip-click"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'tooltip-click', type: TooltipTypes): void;
}), expose: any, slots: any, attrs: any }) {





const handleTooltipClick = (type: TooltipTypes) => {
  emit('tooltip-click', type);
};

return { __sfc: true,emit, handleTooltipClick, TextDisplay, TooltipTypes }
}

})